export let  interventions = [
	{
		id: 1,
		title:'<strong>Survey</strong> population and health risks',
		firstname:'Survey populations and health risks', 
		lastname:'to know what makes people sick or at risk',
		code: 'S',
		keyelements:[
			{
				id: 1,code:"S1",title:"System of regular population-based health surveys",
				blocks:[]
			},
			{
				id: 1,code:"S2",title:"Surveillance of public health threats",
				blocks:[]
			},
			{
				id: 1,code:"S3",title:"Regular population census",
				blocks:[]
			},
		],
		svg: '<svg class="anm-score s" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"> <g> <path class="path1" d="M-14988.416000,3463.617000C-14929.433000,3467.753000,-14886.152000,3484.417000,-14816.635000,3520.110000"/> <path class="path2" d="M-14838.575000,3842.549000C-14989.094000,3820.318000,-15050.515000,3743.678000,-15029.790000,3647.256000C-15014.080000,3562.946000,-14945.938000,3512.865000,-14816.633000,3524.973000" /> <path class="path3" d="M290.431000,391.594000C456.248000,424.485000,528.308000,485.111000,524.175000,565.394000" /> <path class="path4" d="M-14996.359000,4118.684000C-14903.612000,4123.175000,-14787.325000,4087.140000,-14782.092000,3958.268000" /> <path class="path5" d="M-15234.925000,4036.832000C-15175.803000,4076.318000,-15114.325000,4114.348000,-14995.231000,4118.032000" /> </g> </svg>',
		text: '<p>Population-based assessments and surveillance systems are universally indispensable to identify risks for infectious diseases like COVID-19. They are also an important tool to measure social determinants not always captured in routine health facility monitoring.</p><p>Novel methods like mobile phone surveys are also reducing the risk of COVID-19 and other infectious disease transmission and are an important tool to measure inequalities like access to and quality of care. Country capacity for systematic data collection is vital for both routine progress reporting and event-based surveillance.</p>',
	},
	{
		id: 2,
		title:'<strong>Count</strong> births, deaths and causes of death',
		firstname:'Count births, deaths and causes of death', 
		lastname:'to know who is born and what people die from',
		code: 'C',
		keyelements:[
			{
				id: 2,code:"C1",title:"Full birth and death registration",
				obs: 1,
				blocks: []
			},
			{
				id: 2,code:"C2",title:"Certification and reporting of causes of death",
				blocks: []
			},
		],
		svg: '<svg class="anm-score c" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"> <g> <path class="path1" d="M-14988.414000,3463.617000C-14932.301000,3463.745000,-14845.014000,3482.173000,-14773.630000,3552.639000"/> <path class="path2" d="M-14028.745000,3787.612000C-14028.745000,3624.002000,-13902.517000,3463.280000,-13709.122000,3463.280000" /> <path class="path3" d="M-14028.745000,3463.280000C-14028.745000,3625.132000,-13902.517000,3784.126000,-13709.122000,3784.126000" /> <path class="path4" d="M-14988.415000,3552.717000C-14932.342000,3552.589000,-14849.203000,3537.411000,-14777.865000,3466.946000" /> </g> </svg>',
		text: '<p>Accurately counting births and deaths is a cornerstone of every health system. This includes strategies to reliably and continuously track fertility rates, mortality rates, cause-of-death distribution and life expectancy.</p><p>Gaps in cause of death and mortality reporting often occur due to late registration of deaths outside healthcare facilities. We must take a coordinated approach to ensure every birth and death event is properly counted, notified and registered.</p>',
	},
	{
		id: 3,
		title:'<strong>Optimize</strong> health service data',
		firstname:'Optimize health service data', 
		lastname:'to ensure equitable, quality services for all',
		code: 'O',
		keyelements:[
			{
				id: 3,code:"O1",title:"Routine facility and community reporting system with patient monitoring",
				obs: 1,
				blocks: []
			},
			{
				id: 3,code:"O2",title:"Regular system to monitor service availability, quality and effectiveness",
				blocks: []
			},
			{
				id: 3,code:"O3",title:"Health service resources: health financing and health workforce",
				blocks: []
			},
		],
		svg: '<svg class="anm-score o" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"> <g> <path class="path1" d="M-14028.744000,3797.644000C-14028.744000,3628.973000,-13899.605000,3463.280000,-13701.744000,3463.280000" /> <path class="path2" d="M-14028.744000,3463.280000C-14028.744000,3630.285000,-13899.605000,3794.342000,-13701.744000,3794.342000" /> <path class="path3" d="M-13701.748000,3797.644000C-13701.748000,3628.973000,-13830.887000,3463.280000,-14028.748000,3463.280000" /> <path class="path4" d="M-13701.748000,3463.279000C-13701.748000,3630.284000,-13830.887000,3794.342000,-14028.748000,3794.342000" /> </g> </svg>',
		text: '<p>Regular, reliable data from health facilities and the resource systems that support them are central to ensuring availability and quality of health services.</p><p>Health facility data support clinical management of patients, disease monitoring, facility management, health sector planning, and monitoring of service coverage and performance. In the wake of COVID-19, these data will be invaluable to assess the impact on health workforce capacity and essential services to improve preparedness going forward.</p>',
	},
	{
		id: 4,
		title:'<strong>Review</strong> progress and performance',
		firstname:'Review progress and performance', 
		lastname:'to make informed decisions',
		code: 'R',
		keyelements:[
			{
				id: 4,code:"R1",title:"Regular analytical reviews of progress and performance, with equity",
				blocks: []
			},
			{
				id: 4,code:"R2",title:"Institutional capacity for analysis and learning",
				blocks: []
			},
		],
		svg: '<svg class="anm-score r" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"> <g> <path class="path1" d="M-12330.481000,3463.279000L-12330.481000,4086.958000" /> <path class="path2" d="M-12044.955000,3462.279000L-12330.713000,3462.279000" /> <path class="path3" d="M-12063.383000,3462.279000L-12330.713000,3462.279000" /> <path class="path4" d="M-12129.271000,3722.911000L-12330.712000,3462.279000" /> <path class="path5" d="M-12067.877000,3833.076000C-11954.836000,3833.076000,-11865.539000,3759.503000,-11865.539000,3649.026000C-11865.539000,3551.931000,-11954.268000,3471.532000,-12047.244000,3471.532000" /> </g> </svg>',
		text: '<p>Reviewing population and institution-based data is important for strategic planning and priority-setting. This intervention underscores the need for – and capacity of – countries to conduct regular, data-driven analytical reviews using the highest possible data standards to make informed decisions, take corrective action, and allocate resources.</p><p>This intervention also indicates the importance of national capacity for health statistics generation, synthesis and analysis. In-country collaboration and response post-COVID-19 will be an essential knowledge base for curating future plans and public health policies.</p>',
	},
	{
		id: 5,
		title:'<strong>Effective</strong> use of data and evidence for policy and action',
		firstname:'Effective use of data policy and action', 
		lastname:'to accelerate progress',
		code: 'E',
		keyelements:[
			{
				id: 5,code:"E1",title:"Data and evidence drive policy and planning",
				blocks: []
			},
			{
				id: 5,code:"E2",title:"Data access and sharing",
				blocks: []
			},
			{
				id: 5,code:"E3",title:"Enabling environment", new: true,
				blocks: []
			},
		],
		svg: '<svg class="anm-score e" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"> <g> <path class="path1" d="M-11925.239000,3462.279000L-12330.713000,3462.279000" /> <path class="path2" d="M-11925.239000,3462.279000L-12330.713000,3462.279000" /> <path class="path3" d="M-11985.166000,3462.279000L-12330.715000,3462.279000" /> <path class="path4" d="M621.639000,0L0,0"/> </g> </svg>',
		text: '<p>Translating data into effective use by multiple stakeholders is a final and critical step in the data lifecycle. It ensures that governments are accountable for health system performance and that every country can adequately define, measure and compile the data required to monitor progress</p><p>Capacity-building and technical and financial resource alignment is also necessary to enable data use. This includes transparent processes for data reporting, storage and dissemination at all levels and quality assurance for data methods. It also includes visualizations to translate data into actionable information for the general public adapted to specific contexts and local communities.</p>',
	}
];